<template>
  <div data-testid="admin-console-layout" class="admin-console-layout">
    <header data-testid="admin-console-layout__header" class="admin-console-layout__header">
      <div class="admin-console-layout__header-title-row">
        <img
          data-testid="admin-console-layout__header-icon"
          src="/img/navicon/app-switcher-platform-shield.svg"
          alt=""
          class="admin-console-layout__header-icon"
          aria-hidden="true"
        />
        <h1 data-testid="admin-console-layout__title" class="admin-console-layout__title">
          Admin console
        </h1>
      </div>
      <div
        v-if="orgName"
        data-testid="admin-console-layout__org-badge"
        class="admin-console-layout__org-badge"
      >
        {{ orgName }}
      </div>
    </header>

    <div data-testid="admin-console-layout__body" class="admin-console-layout__body">
      <admin-console-side-nav
        :active-key="activeNavKey"
        @nav-click="onNavClick"
      />

      <main data-testid="admin-console-layout__main" class="admin-console-layout__main">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import AdminConsoleSideNav from './AdminConsoleSideNav.vue';
import { ADMIN_CONSOLE_NAV, ADMIN_CONSOLE_ROUTES, buildAdminConsoleRouteQuery } from '@/modules/admin/utils/adminConsoleConstants';

export default {
  name: 'AdminConsoleLayout',
  components: { AdminConsoleSideNav },
  computed: {
    orgName() {
      const clientId = this.$store.state.client || this.$route.query.cid;
      const client = (this.$store.state.clientlist || []).find((c) => c._id === clientId);
      return client?.name || client?.displayname || '';
    },
    activeNavKey() {
      const path = this.$route.path || '';
      if (path.startsWith(ADMIN_CONSOLE_ROUTES.DATA_CONFIGURATION)) return 'data-configuration';
      if (path.startsWith(ADMIN_CONSOLE_ROUTES.AGENT_SETTINGS)) return 'agent-settings';

      const match = ADMIN_CONSOLE_NAV.find((item) => item.href && path.startsWith(item.href));
      return match?.key || 'agent-settings';
    },
  },
  methods: {
    onNavClick(item) {
      if (!item?.href) return;
      if (this.$route.path === item.href) return;

      const query = buildAdminConsoleRouteQuery(this.$route, this.$store.state.client);

      this.$router.push({ path: item.href, query }).catch((err) => {
        if (err?.name === 'NavigationDuplicated') return;
      });
    },
  },
};
</script>

<style lang="scss" scoped src="./AdminConsoleLayout.scss"></style>
